<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div class="main" v-if="showMain">
    <div class="frour">
      <div>
        <!-- <dv-border-box-10> -->
          <FrameControl>
            <Feedback></Feedback>
          </FrameControl>
        <!-- </dv-border-box-10> -->
      </div>

      <div>
        <!-- <dv-border-box-10> -->
          <FrameControl>
            <Purchase></Purchase>
          </FrameControl>
        <!-- </dv-border-box-10> -->
      </div>
      <div>
        <div style="width: 100%; height: 100%">
          <!-- <dv-border-box-10> -->
            <FrameControl>
            <Participate></Participate>
            </FrameControl>
          <!-- </dv-border-box-10> -->
        </div>
      </div>

      <div>
        <FrameControl>
        <!-- <dv-border-box-10> -->
          <div class="icondiv">
            <div>
              <el-button type="text"
                         @click="MarketReport">
                <div>
                  <div>
                    <i class="icon iconfont icon-shujukanban"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>市场调研分析</div>
                </div>
              </el-button>
            </div>
            <div>
              <el-button type="text"
                         @click="PlaceOfOrigin">
                <div>
                  <div>
                    <i class="icon iconfont icon-shujufenxi"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>举办地区数据分析</div>
                </div>
              </el-button>
            </div>

            <div>
              <el-button type="text"
                         @click="MarketingDataManagement">
                <div>
                  <div>
                    <i class="icon iconfont icon-shujuguanli2"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>营销数据管理</div>
                </div>
              </el-button>
            </div>
            <div>
              <el-button type="text"
                         @click="FeedbackData">
                <div>
                  <div>
                    <i class="icon iconfont icon-yonghufankui"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>反馈数据管理</div>
                </div>
              </el-button>
            </div>
            <div>
              <el-button type="text"
                         @click="ProcessData">
                <div>
                  <div>
                    <i class="icon iconfont icon-guochengguanli"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>过程数据分析</div>
                </div>
              </el-button>
            </div>
            <div>
              <el-button type="text"
                         @click="Summarize">
                <div>
                  <div>
                    <i class="icon iconfont icon-04SFA_gongzuozongjiechaxun-01"
                       style="font-size:calc(100vw * 80 / 1920)"></i>
                  </div>
                  <div>会展数据总结</div>
                </div>
              </el-button>
            </div>
          </div>
        <!-- </dv-border-box-10> -->
        </FrameControl>
      </div>
    </div>
    <SpeciesAnalyzed :closeValue="'TypeBiome'"
                     @closeMoule="closeMoule"></SpeciesAnalyzed>
  </div>
</ShowControl>

</template>

<script>

import { mapState } from "vuex";
import Feedback from "../DataAnalysis/Feedback.vue"
import Participate from "../DataAnalysis/Participate.vue"
import Purchase from "../DataAnalysis/Purchase.vue"
import ShowControl from "../UserControl/ShowControl.vue"
import FrameControl from "../UserControl/FrameControl.vue"
export default {
  components: {
    Feedback,
    Participate,
    Purchase,
    ShowControl,
    FrameControl,
  },
  data () {
    return {
      MarketingDataManagementCardView: false,
      MarketReportCardView: false,
      SummarizeCardView: false,
      PlaceOfOriginCard: false,
      InvoiceCardView: false,
      FeedbackDataCardView: false,
      ProcessDataCardView: false,
      PlaceOfOriginDetailView:false,
      MarketingDataDetailCardView:false,
      Financialdata: {},
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      title: '数据分析',
      showMain: true,
      areaFrom: {},
      marktingFrom:{}
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  watch: {
    Round (val) {
      if (val >= 0) {
        console.log(val);
        //this.loadmd();
      }
    },
  },
  created () {
  },
  beforeRouteUpdate(to,from,next)
  {
    next(vm=>
    {
      console.log(vm);
    })
    if (to.query.str != undefined) {
      this.cardview(to.query.str);
    }
  },
  mounted () {
    if (this.$route.query.str != undefined) {
      this.cardview(this.$route.query.str);
    }
  },
  provide () {
    return {
      GetAllLoanTypes: this.GetAllLoanTypes
    }
  },
  methods: {
    cardview(str)
    {
      if(str=='MarketingDataManagementCard')
      {
        this.$router.push("/MarketingDataManagementCard")
      }
    },
    MarketReport () {
      this.$router.push("/MarketReportCard")
    },
    PlaceOfOrigin () {
      this.$router.push("/PlaceOfOriginCard")
    },
    MarketingDataManagement () {
      this.$router.push("/MarketingDataManagementCard")
    },
    ProcessData () {
      this.$router.push("/ProcessDataCard")
    },
    FeedbackData () {
      this.$router.push("/FeedbackDataCard")
    },
    Summarize () {
      if (this.flowID != this.Global.FlowList.实验总结) {
        this.$message.error("当前流程阶段不是实验总结，无法进行操作！");
        return;
      }
      this.$router.push("/SummarizeCard")
    },
    revertClick(){
      if(this.PlaceOfOriginDetailView)
      {
        this.PlaceOfOriginDetailView =false
        this.PlaceOfOrigin()
      }
      else if(this.MarketingDataDetailCardView){
        this.MarketingDataDetailCardView = false
        this.MarketingDataManagement()
      } 
      else{
        this.showMain=true
        this.title = '数据分析'
      }
    },
    AreaFrom(data){
      this.PlaceOfOriginCard = false
      this.areaFrom = data
      this.PlaceOfOriginDetailView = true
    },
    MarktingFrom(data){
      this.MarketingDataManagementCardView = false
      this.marktingFrom =data
      this.MarketingDataDetailCardView = true
    }
  },
};
</script>

<style lang="less" scoped>
.icondiv {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  height: 100%;
  align-content: center;
  align-items: center;
  overflow: auto;
  > div {
    display: flex;
    width: 30%;
    text-align: center;
    height: 45%;
    justify-content: center;
  }
}
</style>
<style scoped>
.main {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
}
.frour {
  /* background-color: #e8e8e8; */
  display: flex;
  /* flex: auto; */
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  border-radius: 0px 0px 15px 15px;
}
.frour > div {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  height: calc((100% - 40px) / 2);
  width: calc((100% - 60px) / 2);
}
</style>
